import { fetchData } from "../../Helpers";

export function registerPack(code) {
  return fetchData({
    endpoint: "/pack/register",
    payload: {
      pack: { code },
      device: "web",
    },
    shouldThrowError: false
  });
}

export function packStats() {
  return fetchData({
    endpoint: "/pack/stats",
    payload: {},
  });
}

export function getPackScanCount(stats) {
  const count = Number(stats?.pack?.month);
  return Number.isFinite(count) ? count : 0;
}

export function resolvePack({ uuid, answers, successCallback, errorCallback }) {
  return fetchData({
    endpoint: "/pack/resolve",
    payload: {
      pack: { uuid },
      activation: { payload: answers },
      device: "web"
    },
    shouldThrowError: false,
    successCallback,
    errorCallback,
  });
}
